<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<classy-layout *ngIf="layout === 'classy'"></classy-layout>

<!-- <settings></settings> -->
